import {
  PermissionsPromptContainer,
  PermissionsPromptContentContainer,
  PermissionsPromptHexagon,
  PermissionsPromptHexagonStroke,
  PermissionsPromptText,
  PermissionsPromptTitle,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPrompt = {
  Container: PermissionsPromptContainer,
  ContentContainer: PermissionsPromptContentContainer,
  Hexagon: PermissionsPromptHexagon,
  HexagonStroke: PermissionsPromptHexagonStroke,
  Title: PermissionsPromptTitle,
  Text: PermissionsPromptText,
};
